import type Configuration from "../types/Configuration";

// The two identifier-bearing fields shared by PatientListEntry (via Patient) and
// MalnutritionPatientSummary — the only shape getPatientIdentifier needs.
interface PatientIdentifierFields {
  mrn: string;
  emr_patient_id: string;
}

// Which identifier a surface shows for a patient, per the customer's
// Configuration.patient_identifier_display. The chosen field is shown as-is,
// with no cross-fallback — the customer picks one and gets exactly that:
//   - "mrn" (default): the MRN.
//   - "emr_patient_id": the EMR patient id (the FIN for Cerner customers like
//     Northside, where Patient.mrn holds the Corporate ID users don't want).
// configuration may be absent (e.g. before it loads) — treat that as the
// default "mrn" behavior.
export const getPatientIdentifier = (
  row: PatientIdentifierFields,
  configuration?: Pick<Configuration, "patient_identifier_display"> | null
): string => {
  if (configuration?.patient_identifier_display === "emr_patient_id") {
    return row.emr_patient_id || "";
  }
  // Patient.mrn is nullable, so coalesce to "" — that is null-safety, not a
  // fallback to the other identifier.
  return row.mrn || "";
};
